import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommunityRepo, CommunityClubsQuery, CommunityClubsPage } from "@app/core/community/domain/community.repo";
import { CommunityClub } from "@app/core/community/domain/model/community-club";
import { CommunityWS } from "@app/core/community/data/network/community.ws";

@Injectable()
export class CommunityDataRepo implements CommunityRepo {
  constructor(private ws: CommunityWS) {}

  getClubs(query: CommunityClubsQuery): Observable<CommunityClubsPage> {
    return this.ws.getClubs(query);
  }

  getClubById(id: string): Observable<CommunityClub> {
    return this.ws.getClubById(id);
  }

  toggleFavorite(id: string, isFavorite: boolean): Observable<boolean> {
    return this.ws.toggleFavorite(id, isFavorite);
  }
}
